import { invoicesConstants } from "../constants/invoicesConstants";

const initialState = {
  sending: false,
  invoicesResponse: {},
  error: "",
  fetching: "",
  invoicesList: {},
    invoicesPaidList: {},
  deletedInvoices: {},
  updatedInvoices: {},
  invoicesData: [],
  fetchInvoices: false,
  fetchingInvoices: false,
  fetchingSites: false,
  sendingInvoicesData: false,
  invoicesUpdate: {},
  executeInvoices: {},
  siteList: {},
  siteDetails: {},
  sendingSiteDetails: false,
  resendStatus: {},
};

export default function invoicesReducer(state = initialState, action) {
  switch (action.type) {
    case invoicesConstants.ADD_INVOICES_REQUEST:
      return {
        ...state,
        sendingInvoicesData: true
      };
    case invoicesConstants.ADD_INVOICES_SUCCESS:
      return {
        ...state,
        sendingInvoicesData: false,
        invoicesResponse: action.invoices,
        error: ""
      };
    case invoicesConstants.ADD_INVOICES_FAILURE:
      return {
        ...state,
        sendingInvoicesData: false,
        error: action.error
      };
    case invoicesConstants.FETCH_INVOICES_REQUEST:
      return {
        ...state,
        fetchingInvoices: true
      };
    case invoicesConstants.FETCH_INVOICES_SUCCESS:
      return {
        ...state,
        fetchingInvoices: false,
        invoicesList: action.invoices.data,
        invoicesData: action.invoices.data.data,
        invoicesResponse: {},
        invoicesUpdate: {},
        error: ""
      };

       case invoicesConstants.FETCH_ALLINVOICES_SUCCESS:
      return {
        ...state,
        fetchingInvoices: false,
        invoicesAllList: action.invoices.data,
        invoicesData: action.invoices.alldata,
        invoicesallData: action.invoices.alldata,
        invoicesResponse: {},
        invoicesUpdate: {},
        error: ""
      };
    case invoicesConstants.FETCH_INVOICES_FAILURE:
      return {
        ...state,
        fetchingInvoices: false,
        error: action.error
      };
    case invoicesConstants.DELETE_INVOICES_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case invoicesConstants.DELETE_INVOICES_SUCCESS:
      return {
        ...state,
        deletedInvoices: action.invoices,
        error: ""
      };
    case invoicesConstants.DELETE_INVOICES_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case invoicesConstants.GET_INVOICES_DETAILS_REQUEST:
      return {
        ...state,
        fetchInvoices: true
      };
    case invoicesConstants.GET_INVOICES_DETAILS_SUCCESS:
      return {
        ...state,
        fetchInvoices: false,
        invoicesDetails: action.invoicesDetails,
        error: ""
      };
    case invoicesConstants.GET_INVOICES_DETAILS_FAILURE:
      return {
        ...state,
        fetchInvoices: false,
        error: action.error
      };
    case invoicesConstants.UPDATE_INVOICES_REQUEST:
      return {
        ...state,
        sendingInvoicesData: true
      };
    case invoicesConstants.UPDATE_INVOICES_SUCCESS:
      return {
        ...state,
        invoicesUpdate: action.updatedInvoices,
        sendingInvoicesData: false,
        error: ""
      };
    case invoicesConstants.UPDATE_INVOICES_FAILURE:
      return {
        ...state,
        error: action.error,
        sendingInvoicesData: false
      };
      case invoicesConstants.EXECUTE_INVOICES_REQUEST:
      return {
        ...state,
        sendingInvoicesData: true
      };
    case invoicesConstants.EXECUTE_INVOICES_SUCCESS:
      return {
        ...state,
        executeInvoices: action.executeInvoices,
        sendingInvoicesData: false,
        error: ""
      };
    case invoicesConstants.EXECUTE_INVOICES_FAILURE:
      return {
        ...state,
        error: action.error,
        sendingInvoicesData: false
      };
    case invoicesConstants.FETCH_SITELIST_REQUEST:
      return {
        ...state,
        fetchingSites: true
      };
    case invoicesConstants.FETCH_SITELIST_SUCCESS:
      return {
        ...state,
        fetchingSites: false,
        siteList: action.sitelist.data,
        error: ""
      };
    case invoicesConstants.FETCH_SITELIST_FAILURE:
      return {
        ...state,
        fetchingSites: false,
        error: action.error
      }; 
    case invoicesConstants.GET_SITE_DETAILS_REQUEST:
      return {
        sendingSiteDetails: true
      };
    case invoicesConstants.GET_SITE_DETAILS_SUCCESS:
      return {
        ...state,
        sendingSiteDetails: false,
        siteDetails: action.sitedata.data
      };
    case invoicesConstants.GET_SITE_DETAILS_FAILURE:
      return {
        ...state,
        sendingSiteDetails: false,
        error: action.error
      };
    case invoicesConstants.POST_RESEND_REQUEST:
      return {
        sending: true
      };
    case invoicesConstants.POST_RESEND_SUCCESS:
      return {
        ...state,
        resendStatus: action.data
      };
    case invoicesConstants.POST_RESEND_FAILURE:
      return {
        ...state,
        error: action.error
      };   
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/invoicesReducers.js